<template>
    <div>
        <div class="shadow-xl grow-0 bg-next-gray-md-dark min-h-10 p-2 grid grid-cols-4 gap-2">
            <span class="col-span-4 text-center font-bold">Riepilogo Fees</span>

            <span class="text-sm font-bold">Nome</span>
            <span class="text-sm font-bold">Valore</span>
            <span class="text-sm font-bold text-right">Budget imponibile</span>
            <span class="text-sm font-bold text-right">Budget lordo IVA</span>

            <span class="col-span-4 border-b"></span>

            <template v-for="f in Fees">
                <span class="text-sm">{{f.nome}}</span>
                <span class="text-sm">{{f.valore}} %</span>
                <span class="text-sm text-right">{{(f.valore * f.budget / 100).toLocaleValueString(2, 2)}} €</span>
                <span class="text-sm text-right">{{(f.valore * f.budget * 0.0122).toLocaleValueString(2, 2)}} €</span>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import { mapGetters } from 'vuex';

@Options({
    name:'HidingToolbar',
    components: {},
    props: {
        fees: Array,
        tab: Object,
    },
    computed: {
        ...mapGetters('sprjDataManager', [
            'VeBudget',
        ]),
    },
})
export default class HidingToolbar extends Vue {

    fees!: any
    tab!: any
    VeBudget!: any

    get Fees() {
        const ret: any[] = []
        this.fees.forEach((fee: any, index: number) => {
            ret.push({
                nome: fee.descrizione,
                valore: fee.valore,
                budget: 0
            })
        })

        this.tab.sezioni.forEach((s: any, i: number) => {
            s.records.forEach((r: any, j: number) => {
                const record_fee = r['ve_fee']
                if(record_fee){
                    const id = record_fee.id
                    ret[id].budget += this.VeBudget(r)
                }
            })
        })

        return ret
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
